import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { BaseGesture, Gesture } from "./gesture";
function extendRelation(currentRelation, extendWith) {
    if (currentRelation === undefined) {
        return _to_consumable_array(extendWith);
    } else {
        return _to_consumable_array(currentRelation).concat(_to_consumable_array(extendWith));
    }
}
export var ComposedGesture = /*#__PURE__*/ function(Gesture) {
    "use strict";
    _inherits(ComposedGesture, Gesture);
    var _super = _create_super(ComposedGesture);
    function ComposedGesture() {
        for(var _len = arguments.length, gestures = new Array(_len), _key = 0; _key < _len; _key++){
            gestures[_key] = arguments[_key];
        }
        _class_call_check(this, ComposedGesture);
        var _this;
        _this = _super.call(this);
        _define_property(_assert_this_initialized(_this), "gestures", []);
        _define_property(_assert_this_initialized(_this), "simultaneousGestures", []);
        _define_property(_assert_this_initialized(_this), "requireGesturesToFail", []);
        _this.gestures = gestures;
        return _this;
    }
    _create_class(ComposedGesture, [
        {
            key: "prepareSingleGesture",
            value: function prepareSingleGesture(gesture, simultaneousGestures, requireGesturesToFail) {
                if (_instanceof(gesture, BaseGesture)) {
                    var newConfig = _object_spread({}, gesture.config);
                    newConfig.simultaneousWith = extendRelation(newConfig.simultaneousWith, simultaneousGestures);
                    newConfig.requireToFail = extendRelation(newConfig.requireToFail, requireGesturesToFail);
                    gesture.config = newConfig;
                } else if (_instanceof(gesture, ComposedGesture)) {
                    gesture.simultaneousGestures = simultaneousGestures;
                    gesture.requireGesturesToFail = requireGesturesToFail;
                    gesture.prepare();
                }
            }
        },
        {
            key: "prepare",
            value: function prepare() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.gestures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var gesture = _step.value;
                        this.prepareSingleGesture(gesture, this.simultaneousGestures, this.requireGesturesToFail);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.gestures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var gesture = _step.value;
                        gesture.initialize();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "toGestureArray",
            value: function toGestureArray() {
                return this.gestures.flatMap(function(gesture) {
                    return gesture.toGestureArray();
                });
            }
        }
    ]);
    return ComposedGesture;
}(Gesture);
export var SimultaneousGesture = /*#__PURE__*/ function(ComposedGesture) {
    "use strict";
    _inherits(SimultaneousGesture, ComposedGesture);
    var _super = _create_super(SimultaneousGesture);
    function SimultaneousGesture() {
        _class_call_check(this, SimultaneousGesture);
        return _super.apply(this, arguments);
    }
    _create_class(SimultaneousGesture, [
        {
            key: "prepare",
            value: function prepare() {
                var _this = this;
                // this piece of magic works something like this:
                // for every gesture in the array
                var simultaneousArrays = this.gestures.map(function(gesture) {
                    return(// we take the array it's in
                    _this.gestures// and make a copy without it
                    .filter(function(x) {
                        return x !== gesture;
                    })// then we flatmap the result to get list of raw (not composed) gestures
                    // this way we don't make the gestures simultaneous with themselves, which is
                    // important when the gesture is `ExclusiveGesture` - we don't want to make
                    // exclusive gestures simultaneous
                    .flatMap(function(x) {
                        return x.toGestureArray();
                    }));
                });
                for(var i = 0; i < this.gestures.length; i++){
                    this.prepareSingleGesture(this.gestures[i], simultaneousArrays[i], this.requireGesturesToFail);
                }
            }
        }
    ]);
    return SimultaneousGesture;
}(ComposedGesture);
export var ExclusiveGesture = /*#__PURE__*/ function(ComposedGesture) {
    "use strict";
    _inherits(ExclusiveGesture, ComposedGesture);
    var _super = _create_super(ExclusiveGesture);
    function ExclusiveGesture() {
        _class_call_check(this, ExclusiveGesture);
        return _super.apply(this, arguments);
    }
    _create_class(ExclusiveGesture, [
        {
            key: "prepare",
            value: function prepare() {
                // transforms the array of gestures into array of grouped raw (not composed) gestures
                // i.e. [gesture1, gesture2, ComposedGesture(gesture3, gesture4)] -> [[gesture1], [gesture2], [gesture3, gesture4]]
                var gestureArrays = this.gestures.map(function(gesture) {
                    return gesture.toGestureArray();
                });
                var requireToFail = [];
                for(var i = 0; i < this.gestures.length; i++){
                    this.prepareSingleGesture(this.gestures[i], this.simultaneousGestures, this.requireGesturesToFail.concat(requireToFail));
                    // every group gets to wait for all groups before it
                    requireToFail = requireToFail.concat(gestureArrays[i]);
                }
            }
        }
    ]);
    return ExclusiveGesture;
}(ComposedGesture);
